// extracted by mini-css-extract-plugin
export var borderRadius = "_dy-4";
export var large = "_dy-3";
export var logoContainer = "_dy-0";
export var nameLogo = "_dy-2";
export var small = "_dy-1";